<div class="dialog">
  <div class="people-container">
    <div class="people" appScrollElement>
      @for (person of people; track person.id; let i = $index) {
        <div>
          <app-link-list-item
            *inView="i < 10; keep: true"
            [description]="''"
            [title]="person.name"
            [link]="['/a/settings/people', person.type === 'user' ? 'user' : 'guest', person.id]"
            [image]="(person | avatarType) === 'image' ? (person | avatar) : undefined"
            [customIcon]="(person | avatarType) === 'svg' ? (person | avatar) : undefined"
            imageStyle="round"
            [size]="'tiny'"
          >
          </app-link-list-item>
        </div>
      }
    </div>
  </div>
</div>
